const path = process.env.PUBLIC_URL

function Cover() {
  return (
    <div className='cover'>
      <div className="cover__wrapper">
        <div className='cover__title'>
          <h1>逃离盛世</h1>
        </div>
        <div className='cover__title'>
          <h1>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;裸命天涯</h1>
        </div>
        <div className='cover__title'>
          <h1>那些润途上的</h1>
          <h1>那些润途上的</h1>
        </div>
        <div className='cover__title'>
          <h1>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中国人</h1>
        </div>
        <img src={`${path}/icon0.png`} className="icon icon0" />
        <img src={`${path}/icon1.png`} className="icon icon1" />
        <img src={`${path}/icon2.png`} className="icon icon2" />
        <img src={`${path}/icon3.png`} className="icon icon3" />
      </div>
      <div className="cover__box">
        <div className="cover__tag">歪脑很特别企划</div>
        <div className="cover__date">05 / 01 / 2023</div>
      </div>
    </div>
  );
}

export default Cover;